/* global google */
/* global jQuery */
/* global require */
angular
  .module('userBlacklist')
  .component('userBlacklist', {
    template: require('./user-blacklist.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'uiGmapGoogleMapApi', 'CenterInfo',
      function UserBlacklistController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        const APIURL = envService.read('apiUrl');
        $rootScope.mainmenu = 'members';
        $rootScope.menu = 'userBlacklist';
        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.moveToWashHistory = $rootScope.moveToWashHistory;
        this.targetPage = 1;
        this.query = '';
        $resource(`${APIURL}/admin/user/blacklist/payonsite`).get({ PAGE: this.targetPage, COUNT: 20 }).$promise
          .then((data) => {
            this.blacklistUsers = data.users;
            this.totalCount = data.totalCount;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          this.targetPage = page;
          $resource(`${APIURL}/admin/user/blacklist/payonsite`).get({ PAGE: page, COUNT: 20, QUERY: this.query }).$promise
            .then((data) => {
              this.blacklistUsers = data.users;
              this.totalCount = data.totalCount;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.showUserView = (blacklistUser) => {
          this.targetBlacklistUser = blacklistUser;
          $resource(`${APIURL}/admin/users/:tb_user_id`).get({ tb_user_id: blacklistUser.TB_USER_ID }).$promise
            .then((data) => {
              if (data.user.NAME === undefined) {
                this.targetUser = { NAME: $translate.instant('탈퇴한 회원입니다.') };
              } else {
                this.targetUser = data.user;
              }
              jQuery('#modal-user-view').modal('show');
            })
            .catch((err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.unregistBlacklist = () => {
          $resource(`${envService.read('apiUrl')}/admin/user/blacklist/${this.targetBlacklistUser.ID}`).delete().$promise
            .then(() => {
              this.blacklistUsers = this.blacklistUsers.filter(blacklistUser => blacklistUser.ID !== this.targetBlacklistUser.ID);
              jQuery('#modal-user-view').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.moveToWashHistory = (user) => {
          jQuery('#modal-user-view').removeClass('fade');
          jQuery('#modal-user-view').modal('hide');
          $location.path(`/member/${user.ID}/wash/history`);
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/user-blacklist/user-blacklist.component.js